import { router } from '@inertiajs/react'
import { showToast } from '@/components/ui'
import type { FlashData } from '@/types'

let installed = false

// Rails flash -> toast. inertia_rails exposes flash as first-class page data
// (excluded from history state, so toasts never replay on back-navigation)
// and Inertia fires a global `flash` event on every visit that carries one.
export function installFlashToasts() {
  if (installed) return
  installed = true

  router.on('flash', (event) => {
    const flash = event.detail.flash as FlashData
    if (flash.notice) showToast({ description: flash.notice, type: 'success' })
    if (flash.alert) showToast({ description: flash.alert, type: 'error' })
  })
}
